import { useAtomValue } from "jotai";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useContext } from "react";

import coinIcon from "@/assets/icons/coin.svg";
import movieIcon from "@/assets/icons/movie.svg";
import InfoLink from "@/components/pages/owner/task/register/components/infoLink";
import Menu from "@/components/shared/menu";
import { LINK_URL } from "@/constants/owner/links";
import { useVenueType } from "@/hooks/owner/task/useVenueType";
import { userDataGlobalAtom } from "@/states/userDataGlobalAtom";
import newWindowIcon from "assets/icons/new-window.svg";
import trial from "assets/images/trial.png";
import Header from "components/shared/header";
import Loading from "components/shared/loading";
import Wrapper from "components/shared/wrapper";
import { AuthContext } from "contexts/auth";

import VenuetypeSkeleton from "./components/venuetypeSkeleton";
import styles from "./index.module.scss";

const OwnerRegisterTask: React.FC = () => {
  const userDataGlobal = useAtomValue(userDataGlobalAtom);
  const { token } = useContext(AuthContext);
  const router = useRouter();
  const { venuetypeList, isVenuetypeLoading } = useVenueType();

  return (
    <>
      <Loading global={false} />
      <Header text="新規募集" profileImage />
      <Wrapper>
        <div className={styles.instruction}>
          募集する不動産のタイプを選びましょう！
        </div>
        <div
          className={`${styles.jump_pricelist_container} mb-7 mt-12 flex flex-col gap-8`}
        >
          <InfoLink link={LINK_URL.PLICE_LIST}>
            <div className="flex items-center gap-8">
              <Image src={coinIcon} alt="価格表" />
              <p>価格表</p>
            </div>
            <div className={styles.icon_container}>
              <Image src={newWindowIcon} alt="価格表を見る" />
            </div>
          </InfoLink>
          {/* ↓初回新規募集するまで表示 */}
          {!userDataGlobal?.has_taskrequest && (
            <InfoLink link={LINK_URL.WORK_FLOW_MANUAL}>
              <div className="flex items-center gap-8">
                <div className="ml-1 mr-[0.2rem]">
                  <Image src={movieIcon} alt="流れ" />
                </div>
                <p>新規募集～報告完了までの流れ</p>
              </div>
              <div className={styles.icon_container}>
                <Image src={newWindowIcon} alt="流れを見る" />
              </div>
            </InfoLink>
          )}
        </div>
        {!token && (
          <a
            className={styles.trial_container}
            href={LINK_URL.REGISTER_TRIAL}
            target="_blank"
            rel="noreferrer"
          >
            <Image
              src={trial}
              alt="初回無料トライアル"
              id="click_register_trial"
            />
          </a>
        )}
        <div className={styles.inner}>
          <div className={styles.venuetype_container}>
            {isVenuetypeLoading
              ? Array.from({ length: 10 }, (_, i) => i + 1).map((value) => (
                  <React.Fragment key={`sk-${value}`}>
                    <VenuetypeSkeleton />
                  </React.Fragment>
                ))
              : venuetypeList.map((venuetype) => {
                  return (
                    <Link
                      href={{
                        pathname: "/owner/task/register/type",
                        query: router.query.couponId
                          ? {
                              venueTypeId: venuetype.id,
                              couponId: router.query.couponId
                            }
                          : { venueTypeId: venuetype.id }
                      }}
                      key={venuetype.id}
                    >
                      <a
                        className={styles.venuetype_box}
                        id={`click_register_type${venuetype.id}`}
                      >
                        <div className={styles.venuetype_image_box}>
                          <div className={styles.venuetype_image}>
                            <Image
                              src={`${process.env.APP_PHOTO_URL}/images/venue/type/${venuetype.id}.jpg`}
                              alt=""
                              layout="fill"
                              objectFit="cover"
                              priority={true}
                            />
                          </div>
                        </div>
                        <div
                          className={styles.venuetype_name}
                          id={`click_register_type${venuetype.id}`}
                        >
                          {venuetype.name.includes("アパート")
                            ? `アパート・マンション\n戸建`
                            : venuetype.name}
                        </div>
                      </a>
                    </Link>
                  );
                })}
          </div>
        </div>
      </Wrapper>
      <Menu type="owner" active="1" />
    </>
  );
};

export default OwnerRegisterTask;
